/* eslint-disable */
let self;
let datalayer;
let page_path;
let origin_page_path;
let origin_page_type;
let origin_content_type;
let origin_content_group;
let search_term;

export class Datalayer_search {
  constructor( datalayer_attr ) { // Receive part of the attributes to create the datalayer
    self = this;
    origin_page_path = datalayer_attr.origin_page_path;
    page_path = datalayer_attr.page_path;

    self.getDatalayerAttr(); // Define the other attributes based on the origin page url

    datalayer = {
      event: 'site_search',
      origin: {
        page_path: origin_page_path,
        page_type: origin_page_type,
        content_group: origin_content_group,
        content_type: origin_content_type,
        content_variant: 'none',
      },
      search_term: search_term,
    };
    // Create and push the datalayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ origin: null }); // Clear the previous origin object.
    window.dataLayer.push(datalayer);

  }

  // Define the other attributes based on the origin page url
  getDatalayerAttr() {
    if ( page_path.indexOf('?') >= 0 ) {
      const url_split = page_path.split('?');
      search_term = url_split[1];
    } else {
      const url_split = page_path.split('/');
      search_term = "city=" + url_split[4];
    }

    const origin_page_sub_path = origin_page_path.split('/');
    if (origin_page_sub_path[3] === '') { // Origin page is home if it hasn't subpath
      origin_page_type = 'main';
      origin_content_group = 'home';
      origin_content_type = 'page';
    } else { // If origin page has subpath
      if (origin_page_path.indexOf('examentraining') >= 0) {
        origin_content_group = 'exam';
      } else if (origin_page_path.indexOf('bijles') >= 0) {
        origin_content_group = 'tutoring';
      } else if (origin_page_path.indexOf('huiswerkbegeleiding') >= 0) {
        origin_content_group = 'homework';
      } else {
        origin_content_group = 'service';
      }
      if (origin_page_path.indexOf('aanmelden') >= 0) {
        origin_page_type = 'overview';
        if (origin_page_path.indexOf('?') >= 0) { // If origin page has query string it is search result
          origin_content_type = 'search_results';
        } else {
          origin_content_type = 'registration';
        }
      } else {
        origin_page_type = 'detail';
        origin_content_type = 'information';
      }
    }
  }
}
